import {
  NetSuiteWriteRequestFormat,
  useArchiveValidationErrorsMutation,
  useClearValidationErrorsMutation,
  useNetSuite_ValidationErrorsTabQuery
} from 'generated/graphql';
import {
  useCallback,
  useMemo
} from 'react';

import * as types from './types';




export interface IWriteRequest {
  id: string;
  format: NetSuiteWriteRequestFormat;
  identifier: string;
  formattedRequestData: string;
  validationErrors: string[];
}

export interface IData {
  writeRequests: IWriteRequest[];
}

export function useQuery(formState: types.IFormState) {
  const tuple = useNetSuite_ValidationErrorsTabQuery({
    variables: {
      storeId: formState.store?.id
    }
  });

  return useMemo(
    () => {
      const data: IData = {
        writeRequests: tuple.data?.netSuiteWriteRequests.nodes.map((node): IWriteRequest => ({
          id: node.id,
          formattedRequestData: JSON.stringify(node.requestData, null, 2),
          format: node.format,
          identifier: node.order?.orderNumber ?? node.customer?.email ?? node.returnAuthorization?.returnNumber ?? '',
          validationErrors: node.validationErrors
        })) ?? []
      };

      return {
        ...tuple,
        data
      };
    },
    [tuple]
  );
}



export function useClearValidationErrors() {
  const [fnMutate, tuple] = useClearValidationErrorsMutation({});

  const fnWrappedMutate = useCallback(
    async (storeId?: string, writeRequestId?: string) => {
      await fnMutate({
        variables: {
          storeId,
          writeRequestId
        }
      });
    },
    [fnMutate]
  );

  return useMemo(
    () => [
      fnWrappedMutate,
      {
        ...tuple,
        data: null
      }
    ] as const,
    [
      fnWrappedMutate,
      tuple
    ]
  );
}

export function useArchiveWriteRequest() {
  const [fnMutate, tuple] = useArchiveValidationErrorsMutation({
    refetchQueries: []
  });

  const fnWrappedMutate = useCallback(
    async (writeRequestId: string) => {
      await fnMutate({
        variables: {
          writeRequestId
        }
      });
    },
    [fnMutate]
  );

  return useMemo(
    () => [
      fnWrappedMutate,
      {
        ...tuple,
        data: null
      }
    ] as const,
    [
      fnWrappedMutate,
      tuple
    ]
  );
}
